import { Chat, Information } from "@carbon/icons-react";
import { Button, Link, Tag } from "@carbon/react";
import { useTranslation } from "react-i18next";
import {
  MaterialOfferResponse,
  MaterialCompaniesOpportunitiesResponse,
} from "../../types";

type MaterialOfferItemProps = {
  materialOffer?: MaterialOfferResponse;
  potencialSupplier?: MaterialCompaniesOpportunitiesResponse;
  handleItemClick: () => void;
  handleChatClick?: () => void;
};

/**
 * One supplier row inside the material detail page's Validated / Alternative / Potential lists.
 * Rebuilt on Carbon: the company name is a Carbon `Link` (keeps the clickable-looking blue name,
 * opens the detail), the two pre-Carbon circular `<div onClick>` + bespoke `TooltipSP` icons are now
 * ghost icon `Button`s (their `iconDescription` is the built-in Carbon tooltip), and the "invited"
 * Tailwind pill is a Carbon `Tag`. Click behaviour is unchanged.
 */
const MaterialOfferItem = ({
  materialOffer,
  handleItemClick,
  handleChatClick,
  potencialSupplier,
}: MaterialOfferItemProps) => {
  const { t } = useTranslation();

  const companyName = potencialSupplier
    ? potencialSupplier?.user?.company?.name
    : materialOffer?.user?.company?.name;

  return (
    <li className="material-suppliers__row">
      <Link
        as="button"
        type="button"
        className="material-suppliers__row-name"
        onClick={handleItemClick}
      >
        {companyName}
      </Link>

      {potencialSupplier?.invited && (
        <Tag type="green" size="sm" className="material-suppliers__row-tag">
          {t("offer.invited")}
        </Tag>
      )}

      <div className="material-suppliers__row-actions">
        <Button
          kind="ghost"
          size="sm"
          hasIconOnly
          renderIcon={Information}
          iconDescription={t("offer.information")}
          tooltipPosition="left"
          onClick={handleItemClick}
        />
        {!potencialSupplier && (
          <Button
            kind="ghost"
            size="sm"
            hasIconOnly
            renderIcon={Chat}
            iconDescription={t("offer.chat")}
            tooltipPosition="left"
            onClick={handleChatClick}
          />
        )}
      </div>
    </li>
  );
};

export default MaterialOfferItem;
